module.exports = __webpack_public_path__ + "assets/payment.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/payment.png
// module id = 1215
// module chunks = 7